import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CardUserPhoto from '../../components/CardUserPhoto';
import CardUserData from '../../components/CardUserData2';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';


import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import NavigationIcon from '@material-ui/icons/Navigation';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

import SaveRoundedIcon from '@material-ui/icons/SaveRounded';

import LoopRoundedIcon from '@material-ui/icons/LoopRounded';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import AdjustRoundedIcon from '@material-ui/icons/AdjustRounded';
import BallotRoundedIcon from '@material-ui/icons/BallotRounded';
import { GetCitasCartillas } from '../../../services/SecurityService';
const styles = theme => ({
    mainContainer: {
        display: 'flex',
       

    }
});

const buttonsProfile = [
  {
    icono:<SaveRoundedIcon/>,
    nombre:"Refrendos",
  
  color:'white',
  colorletra:'#00A8A9',
  borderColor:'#027272',

  
  
},

  {nombre:"En Proceso",icono:<LoopRoundedIcon/>,color:'white',colorletra:'#F3B122'},
//  "Recibidos",
{icono:<CheckCircleRoundedIcon/>,nombre:"Concluido Positivo",colorletra:'#44AC34',borderColor:'#44AC34',color:"white"},
{icono:<CancelRoundedIcon/>,nombre:"Concluido Negativo",colorletra:'#D3065B',borderColor:'#D3065B',color:"white"},
{icono:<AdjustRoundedIcon/>,nombre:"Para Inspección",colorletra:'#606060',borderColor:'#606060',color:"white"},
{icono:<BallotRoundedIcon/>,nombre:"Con Licencia",colorletra:'#274178',borderColor:'#274178',color:"white"},];

const buttonsProfileND = [
  {
    icono:<SaveRoundedIcon/>,
    nombre:"Refrendos",
  
  color:'white',
  colorletra:'#00A8A9',
  borderColor:'#027272',

  
  
},

  {nombre:"En Proceso",icono:<LoopRoundedIcon/>,color:'white',colorletra:'#F3B122'},
//  "Recibidos",
{icono:<CheckCircleRoundedIcon/>,nombre:"Concluido Positivo",colorletra:'#44AC34',borderColor:'#44AC34',color:"white"},
{icono:<CancelRoundedIcon/>,nombre:"Concluido Negativo",colorletra:'#D3065B',borderColor:'#D3065B',color:"white"},
{icono:<AdjustRoundedIcon/>,nombre:"Para Inspección",colorletra:'#606060',borderColor:'#606060',color:"white"},
{icono:<BallotRoundedIcon/>,nombre:"Con Licencia",colorletra:'#274178',borderColor:'#274178',color:"white"},];

class SecurityProfile2 extends Component {

    constructor(props){
        super(props);

        this.handleButtonsEvents = this.handleButtonsEvents.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.stopEditing = this.stopEditing.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.startEditing = this.startEditing.bind(this);

        const {user} = props;
        this.state = {
            
            data: [{
                Usuario: user.userData.Usuario,
                Correo: user.userData.Correo,
                id_usuario: user.userData.IdUsuario, 
                iduser:user.userData.iduser, 
            }],
            titulo : '',
            userD : user,
            editIdx: -1,
            oficios:[],
            oficiosR : [],
            oficiosEP: [],
            oficiosTAA: [],
            respuestaP: [],
            respuestaN: [],
            respuestaS: [],
            oficiosLic:[],
            etiquetA: '',
            index:0
        };
    }

    componentDidMount(){
// este va ser para refrendos
     
        console.log("el  usuario")
        console.log(this.state.userD)


        GetCitasCartillas().then(response => {
            //if(response=="")
    
            if(response!="No existen clientes en la BBDD."){
           
                let a=[]
                response.forEach((element,index) =>{
                    a.push({ id: element.id,
                        title: element.fecha_cita.substring(11,16)+" - "+element.nombre+' '+element.ap_paterno,
                        start:new Date(element.fecha_cita),
                        end: new Date(element.fecha_cita),
                        desc: element.nombre+' '+element.ap_paterno})
              
                   });
          this.setState({ 
            oficios: a,
            oficiosR:a,
            oficiosEP:response
    
    
    
          
          })
    
      
        }else{
            this.setState({ 
                oficios: [],
                oficiosR:[],
        
        
        
              
              })  
        }
          console.log("Aqui estan los oficios preRegistrados")
          console.log(response)
        }).catch(err =>  this.setState({ 
            oficios: [],
            oficiosR:[],
    
    
    
          
          })  );  
    
    }

    handleButtonsEvents(event, index){
        const {user} = this.props;

        if(this.state.userD.userData.IdUsuario==453){
           
            switch(index){
                case 0:
                this.setState({
                   oficios : this.state.oficiosR,
                   titulo : 'Registro de Oficios',
                   etiquetA : AddIcon,
                   index:0
    
                });
                break;
                case 1:
                this.setState({
                    oficios : this.state.oficiosEP,
                    titulo : 'Oficios Turnados',
                    etiquetA : DeleteIcon ,
                    index:1
                });
                break;
                {/*case 2:
                this.setState({
                    oficios : this.state.oficiosTAA,
                    titulo : 'Oficios Turnados Recibidos',
                    etiquetA : NavigationIcon ,
                    index:2
                });
              break;*/}
                case 2:
                this.setState({
                    oficios : this.state.respuestaP,
                    titulo : 'Oficios Concluidos Positivos',
                    etiquetA : ArrowDownwardIcon ,
                    index:2
                });
                break;
                case 3:
                    this.setState({
                        oficios : this.state.respuestaN,
                        titulo : 'Oficios Concluidos Negativos',
                        etiquetA : ArrowDownwardIcon ,
                        index:3
                    });
                    break;
                    case 4:
                      this.setState({
                          oficios : this.state.respuestaS,
                          titulo : 'Oficios Para Inspección',
                          etiquetA : ArrowDownwardIcon ,
                          index:4
                      });
                      break;
                      case 5:
                        this.setState({
                            oficios : this.state.oficiosLic,
                            titulo : 'Oficios Licencia',
                            etiquetA : ArrowDownwardIcon ,
                            index:5
                        });
                        break;
                default: 
                break;

          } 
        }
         else{
           
            switch(index){
                case 0:
                this.setState({
                    oficios : this.state.oficiosTAA,
                    titulo : 'Oficios Turnados Recibidos',
                    etiquetA : NavigationIcon ,
                    index:0
    
                });
                break;
                case 1:
                this.setState({
                    oficios : this.state.respuestaP,
                    titulo : 'Oficios Concluidos Positivos',
                    etiquetA : ArrowDownwardIcon ,
                    index:1
                });
                break;
                case 2:
                this.setState({
                    oficios : this.state.respuestaN,
                        titulo : 'Oficios Concluidos Negativos',
                        etiquetA : ArrowDownwardIcon ,
                        index:2
                });
                break;
                case 3:
                      this.setState({
                          oficios : this.state.respuestaS,
                          titulo : 'Oficios Para Inspección',
                          etiquetA : ArrowDownwardIcon ,
                          index:3
                      });
                      break;
                default:
                break;

          } 
       
        }
    
}


    handleRemove(i){
        this.setState(state => ({
          data: state.data.filter((row, j) => j !== i)
        }));
    };
    
    startEditing(i){
        this.setState({ editIdx: i });
    };
    
    stopEditing(i){
        this.setState({ editIdx: -1 });
        //PostTypeCompetences(this.state.data[i]);
    };
    
    handleChange(e, name, i){
        const { value } = e.target;
        this.setState(state => ({
          data: state.data.map(
            (row, j) => (j === i ? { ...row, [name]: value } : row)
          ),
        }));
      };

    render(){
        const {classes} = this.props;
let botones;
        if(this.state.userD.userData.IdUsuario==453){
botones=buttonsProfile
        }else{
            botones=buttonsProfileND 
        }
        return(
        <div className={classes.mainContainer}>
            
        

            <CardUserData tableHeader={this.state.header}
            buttons={botones}     
            onClick={this.handleButtonsEvents}       
              tableData={this.state.data}
              oficiosR={this.state.oficios}
              oficiosEP={this.state.oficiosEP}
              etiqueta={this.state.titulo}
          //    etiquetA={this.state.etiquetA}
          indice={this.state.index}
              usuario={this.state.data[0].id_usuario}
              iduser={this.state.data[0].iduser}
              handleButtonsEvents={this.handleButtonsEvents}
              handleRemove={this.handleRemove}
              stopEditing={this.stopEditing}
              handleChange={this.handleChange}
              startEditing={this.startEditing}
              editIdx={this.state.oficios} />
        </div>
        );
    }
}



SecurityProfile2.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
    return {
        user: state.security
    };
};

export default connect(mapStateToProps)(withStyles(styles)(SecurityProfile2));